import React from "react";

export default function CustomTooltip({ active, payload, label, chartType }) {
  const tooltipTitle =
    chartType === "calorie"
      ? "تغییرات کالری"
      : chartType === "size"
      ? "تغییرات سایز ماهیانه"
      : "تغییرات وزن هفته";
  if (active && payload && payload.length) {
    return (
      <div className="chartCustomTooltip">
        <p className="chartCustomTooltipText">{label}</p>
        <p className="chartCustomTooltipText">
          {tooltipTitle}:{" "}
          <span className="chartCustomTooltipValue">{payload[0].value}</span>
        </p>
      </div>
    );
  }

  return null;
}
